import React from 'react';
import BrandPage from './BrandPage';

const ReclaimPage = () => <BrandPage brandSlug="reclaim" />;

export default ReclaimPage;
